import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivationEnd, Router, RouterModule, ActivatedRoute } from '@angular/router';
import { AdminCommunicationService } from '@services/communication/communication.service';
import { LocalStorageService } from '@services/local-storage/local-storage.service';
import { NotificationService } from 'app/services/notification.service';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-navbar',
	imports: [CommonModule, RouterModule],
	templateUrl: './navbar.html',
	styleUrl: './navbar.scss'
})
export class Navbar {

	heading: string = '';
	notificationCount : number = 0;
	userDetails: any;
	totalUnreadCount$!: Observable<number>;
	constructor(public _route: Router, 
		private activatedRoute: ActivatedRoute, 
    private notificationService: NotificationService,
		private chatService: AdminCommunicationService,
		private readonly _localStorageService: LocalStorageService,
	) {
		this.userDetails = JSON.parse(this._localStorageService.getUser());
		// Listen for navigation events
		this._route.events.subscribe((event: any) => {
			if (event instanceof ActivationEnd) {
				if (event.snapshot.data && Object.keys(event.snapshot.data).length > 0) {
					this.heading = event.snapshot.data['heading'] || '';
				}
			}
		});

		// Set heading on initial load (refresh)
		const lastChild = this.getLastChild(this.activatedRoute);
		if (lastChild.snapshot.data && lastChild.snapshot.data['heading']) {
			this.heading = lastChild.snapshot.data['heading'];
		}
	}

	private getLastChild(route: ActivatedRoute): ActivatedRoute {
		while (route.firstChild) {
			route = route.firstChild;
		}
		return route;
	}

	goBack() {
		history.back()
	}
	ngOnInit() {
		this.notificationService.notificationCount$.subscribe(count => {
        this.notificationCount = count;
      });
	  this.totalUnreadCount$ = this.chatService.getTotalUnreadCount(this.userDetails?.userId);
	}



}
